import React from 'react';
import {Button, List, Tooltip} from "antd";
import UserSmall from "../Boilerplate/UserSmall";
import {compose} from "redux";
import {connect} from "react-redux";
import {acceptJoinRequest, getJoinRequests, rejectJoinRequest} from "../../actions/companies";
import {withTransparentLoading} from "../Boilerplate/deferLoaderHoc";

class _CompanyJoinRequests extends React.Component {
  handleAccept = (id) => {
    const { onAccept } = this.props;
    onAccept && onAccept(id);
  };

  handleReject = (id) => {
    const { onReject } = this.props;
    onReject && onReject(id);
  };

  render() {
    const { joinRequests } = this.props;
    return (
      <List
        size={'small'}
        dataSource={Object.values(joinRequests)}
        locale={{ emptyText: 'No pending requests' }}
        renderItem={request =>
          <List.Item actions={[
            <Tooltip title={'Add user to company'}>
              <Button icon={'check'} onClick={() => this.handleAccept(request.contactuserid)}/></Tooltip>,
            <Tooltip title={"Reject user's request to join"}>
              <Button icon={'close'} onClick={() => this.handleReject(request.contactuserid)}/></Tooltip>
          ]}>
            <List.Item.Meta title={<UserSmall id={request.contactuserid}/>}/>
          </List.Item>
        }
      />
    );
  }
}

export const CompanyJoinRequests = compose(
  connect(
    (state, props) => ({
      joinRequests: state.ui.companyJoinRequests,
    }),
    (dispatch, props) => ({
      loader: () => dispatch(getJoinRequests()),
      onAccept: id => dispatch(acceptJoinRequest(id)),
      onReject: id => dispatch(rejectJoinRequest(id)),
    })
  ),
  withTransparentLoading
)(_CompanyJoinRequests);



// WEBPACK FOOTER //
// ./src/components/Settings/CompanyJoinRequests.js